import { render, staticRenderFns } from "./roomRules.vue?vue&type=template&id=2a280813&lang=pug&"
import script from "./roomRules.vue?vue&type=script&lang=js&"
export * from "./roomRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports